import React from 'react';
import ReactDOM from 'react-dom';
import SubscriptionExpiredPopup from 'components/subscription-expired-popup';

export const isSubscriptionExpiredResponse = (error: any): boolean => {
  const status = error?.response?.status;
  const message = String(error?.response?.data?.message || '');
  if (status === 401 && message === 'Subscriptions expired') return true;
  if (status === 602 && /subscription expired/i.test(message)) return true;
  return false;
};

export const showSubscriptionExpiredPopup = (onLogout: () => void) => {
  if (document.getElementById('subscription-expired-popup-root')) return;

  const storedUser = localStorage.getItem('user');
  let isAdmin = false;
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      isAdmin = Boolean(
        parsedUser.accessLevel === 'ADMIN' || parsedUser.accessLevel === 'OWNER'
      );
    } catch (_) {}
  }

  const root = document.createElement('div');
  root.id = 'subscription-expired-popup-root';
  document.body.appendChild(root);

  const cleanup = () => {
    ReactDOM.unmountComponentAtNode(root);
    root.remove();
  };

  ReactDOM.render(
    React.createElement(SubscriptionExpiredPopup, {
      isVisible: true,
      isAdmin,
      onLogout: () => {
        onLogout();
        cleanup();
      },
      onDismiss: cleanup,
    }),
    root
  );
};
